import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';

/**
 * Contains the following {FormControl}s for `renting` your home:
 * * HousingContactName *
 * * HousingContactPhone *
 * * MonthlyCost *
 *
 * Contains the following {FormControl}s for `owning` your home:
 * * MortgageBalance *
 * * Lienholder *
 * * MarketValue *
 *
 * Contains the following {FormControl}s for renting or living with `parents/relatives`:
 * * MonthlyCost *
 *
 * (*) Denotes a control that can be disabled.
 *
 * The parent {FormGroup} can disable unneeded controls. Disabling will hide the controls from the UI.
 *
 * ```typescript
 * this.formBuilder.group({
 *    LandlordName: [{ value: '', disabled: true }]
 * });
 * ```
 */
@Component({
  selector: 'app-rent-info',
  templateUrl: './rent-info.component.html',
  styleUrls: ['./rent-info.component.scss'],
})
export class RentInfoComponent implements OnInit {
  @Input() controls: {
    [key: string]: AbstractControl;
  } = {};

  constructor() {}

  ngOnInit(): void {}

  getFormControl(key: string): FormControl {
    return this.controls[key] as FormControl;
  }

  controlIsRequired(key: string): boolean {
    if (
      this.controls[key] &&
      this.controls[key].hasValidator(Validators.required)
    ) {
      return true;
    }

    return false;
  }

  controlIsDisabled(key: string): boolean {
    if (this.controls[key]) {
      return this.controls[key].disabled;
    }

    return false;
  }
}
